import React from 'react';
import '../styles/PropertyDistance.css';

function PropertyDistance(props) {
    const property = props.property;
    return (
        <div className="property-distance-container">
            <span className="body-regular colour-secondary">
                Distance
            </span>
            {
                property.compDetails.distanceMiles === null ?
                <span className="body-bold colour-primary">
                    N/A
                </span>
                :
                <span className="body-bold colour-primary">
                    {property.compDetails.distanceMiles.toFixed(2)}mi
                </span>
            }
        </div>
    )
};

export default PropertyDistance;